import { render, staticRenderFns } from "./AddAutomaticSentenceForm.vue?vue&type=template&id=1d4d4ed7&scoped=true"
import script from "./AddAutomaticSentenceForm.vue?vue&type=script&lang=js"
export * from "./AddAutomaticSentenceForm.vue?vue&type=script&lang=js"
import style0 from "./AddAutomaticSentenceForm.vue?vue&type=style&index=0&id=1d4d4ed7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4d4ed7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VSelect,VTextarea})
